var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"file-input"},[_c('input',{staticClass:"file-input",attrs:{"id":_vm.id,"type":"file","accept":_vm.accept},on:{"change":_vm.handleUpload}})])
}
var staticRenderFns = []

export { render, staticRenderFns }